export default __webpack_public_path__ + "static/media/8.3e81019d.webp";